import { useState, useEffect, useRef } from 'react';
import { useAPIV2 } from '../../yoello-lib/modules/API2/useAPIv2';
import { HTTPMethods } from '../../yoello-lib/modules/API/API';
import APIExtensions from '../../yoello-lib/modules/API2/APIDefs';
import { useSelector } from 'react-redux';
import { IReduxAppState } from '../../reducers';


export const usePollSyncs = () => {
    const pollRef = useRef<any>();
    const [ pollData, setPollData] = useState([]);
    const [ syncIds, setSyncIds ] = useState<string[]>([]);
    const [ successes, setSuccesses ] = useState<any>([]);
    const [ cancels, setCancels ] = useState<any>([]);
    const [ fails, setFails ] = useState<any>([]);
    const [ finisheds, setFinisheds ] = useState<any>([]);
    const isEposNow = useSelector((state: IReduxAppState) => state.isEposNow);

    const { callAPI } = useAPIV2(APIExtensions.partnerSyncSearch, {
        onMountDisabled: true,
    });

    const resetState = () => {
        setPollData([]);
        setSyncIds([]);
        setSuccesses([]);
        setCancels([]);
        setFails([]);
        setFinisheds([]);
    }

    const fetchData = () => {
        if(syncIds.length < 1) return;
        // The if should be removed once EposNow menu sync is the same with other integrations on back-end side
        if(isEposNow){
            callAPI(HTTPMethods.POST, {
                body: {
                    "filters": [
                        {
                            "field_name": "id",
                            "operator": "in",
                            "value": syncIds
                        }
                    ]
                },
            }).then(response => {
                //@ts-ignore
                setPollData(response.data);
            })
        }else{
            callAPI(HTTPMethods.POST, {
                body: {
                    "filters": [
                        {
                            "field_name": "id",
                            "operator": "in",
                            "value": syncIds
                        }
                    ]
                },
            }).then(response => {
                //@ts-ignore
                setPollData(response.data);
            })
        }
        
    }

    const startPolling = () => {
        fetchData();
        if(pollRef.current){
           clearInterval(pollRef.current); 
        }
        pollRef.current = setInterval(fetchData, 5000);
    }

    const stopPolling = () => {
        clearInterval(pollRef.current)
    }

    useEffect(() => {
        return stopPolling();
    }, [])

    useEffect(() => {
        startPolling();
        //eslint-disable-next-line
    }, [syncIds])

    useEffect(() => {
        //@ts-ignore
        setSuccesses(pollData.filter(item => item.status === 'SUCCESSFUL'));
        //@ts-ignore
        setCancels(pollData.filter(item => item.status === 'CANCELLED'));
        //@ts-ignore
        setFails(pollData.filter(item => item.status === 'FAILED'));
    }, [pollData])

    useEffect(() => {
        setFinisheds([...fails, ...successes, ...cancels]);
    }, [fails, successes, cancels])

    return {
        pollData,
        startPolling,
        stopPolling,
        setSyncIds,
        fails,
        successes,
        cancels,
        finisheds,
        resetState
    }
}